<template lang="html">
  <keep-alive>
    <div>
      <Header :showInfo="showinfo" />
      <div style="height: .5rem;"></div>
      <DataPanel />
      <KuaishouTextAd />
      <!-- <Ad class="head-ad" width="3.45rem"/> -->
      <!-- <ExpressNews /> -->
      <MainChart />
      <!-- <Tabs v-if="canload" /> -->
      <div
        v-if="!isKuaishouChannel"
        style="position:fixed;bottom:0;width:100%;z-index:9999;background:#fff;box-shadow: 0 0 0.04rem 0 rgba(0,0,0,0.25);">
        <Logo @openAppStore="openAppStore" />
      </div>
    </div>
  </keep-alive>
</template>

<script>
import Header from './Header/index.vue'
import DataPanel from './DataPanel/index.vue'
import ExpressNews from './ExpressNews/index.vue'
import MainChart from './MainChart/index.vue'
import Logo from './Logo/index.vue'
// import Tabs from './Tabs/index.vue'
import { request } from '@/api/request'
import { mapState, mapMutations } from 'vuex'
import OpenModal from '@/utils/modal';
import Ad from '../advertisement/index.vue'
import { getIsIndexStock } from '@/utils/formatStockInfo'
import ScTrack from '@/utils/track'
import KuaishouTextAd from '@/components/KuaishouTextAd.vue';
import { isKuaishouSearch, getKuaishouQuery } from '@/utils/kuaishouQuery';

export default {
  components: {
    Header,
    DataPanel,
    // ExpressNews,
    MainChart,
    Logo,
    // Tabs,
    KuaishouTextAd
  },
  data() {
    return {
      showinfo: false,
      canload: false,
      iscre: false,
      toTop: this.$route.query.toTop || 0,
      isKuaishouChannel: false
    }
  },
  computed: {
    ...mapState(['homeScrollTop'])
  },
  async created() {
    this.checkKuaishouChannel()
    this.loadScript()
    this.iscre = true
    await this.createInit()
    this.$router.options.routes.filter(_ => _.name === 'Home')[0].meta.keepAlive = true
    this.iscre = false
  },
  async activated() {
    if (!this.iscre) {
      this.toTop = this.$route.query.toTop || 0
      await this.createInit()
    }
  },
  methods: {
    ...mapMutations(['setHomeScrollTop', 'setHomeAdvertisement']),
    checkKuaishouChannel() {
      const from = this.$route.query.from
      this.isKuaishouChannel = from === 'kuaishou_search'
    },
    async createInit() {
      console.log('this.$route', this.$route, this.$route.params)
      // 新订阅：setSymbol 触发 store/data.js 的 subscribe，使用 websocketV2
      if (this.$route.params.code) this.$store.commit('setSymbol', this.$route.params)
      else this.$store.commit('setSymbol', this.$route.query)
      let stockname = await this.getStockName()
      this.$store.commit('setStockName', stockname)
      this.canload = true
      //获取广告
      this.getAd()
      // this.toTop = this.$route.query.toTop || 0
      this.scrollAddListen()
    },
    async getAd() {
      let res = await request.get({
        url: request.apis.activity.activity,
        params: {
          activityStatus: 'NOW',
          hiddenStatus: 'SHOWN',
          orderBy: 'sort',
          direction: 'asc',
          position: this.$store.state.isIndex ? 'flgmgzsmob_stockdetail' : 'flgmgmob_stockdetail'
        }
      })
      if (res.list && res.list.length) {
        this.setHomeAdvertisement(res.list)
      }
    },
    scrollAddListen() {
      console.log('1231', this.toTop)
      window.onscroll = null
      window.onscroll = () => {
        this.setHomeScrollTop(window.scrollY)
        if (window.scrollY > 30) {
          this.showinfo = true
        } else this.showinfo = false
      }
      window.scrollTo(0, this.toTop)
    },
    /**
     * 获取个股名称
     */
    async getStockName() {
      function marketTransform(val) {
        let keytmar = {
          NASDAQ: 'NASDAQ',
          nasdaq: 'NASDAQ',
          NA: 'NASDAQ',
          sh: 'sh',
          SH: 'sh',
          sz: 'sz',
          SZ: 'sz',
          HK: 'HKSE',
          hk: 'HKSE',
          hkse: 'HKSE',
          AMEX: 'AMEX',
          amex: 'amex',
          AM: 'AMEX',
          am: 'AMEX',
          HKIDX: 'HKIDX',
          hkidx: 'HKIDX'
        }
        return keytmar[val] || val.toUpperCase()
      }
      console.log(this.$store.state.market)
      let market = marketTransform(this.$store.state.market)
      let symbol = this.$store.state.code
      if (this.$store.state.isIndex && this.$store.state.region === 'CN') market = market.toLowerCase()
      if (this.$store.state.region === 'HK') {
        symbol = symbol.length === 4 && /\d+/.test(symbol) ? '0' + symbol : symbol
      }
      if (symbol.toUpperCase() === 'BRKA' || symbol.toUpperCase() === 'BRKB') {
        symbol = 'BRK' + symbol.slice(-1).toLowerCase()
      }
      let res = await request.get({
        url: request.apis.quote.getStockName,
        params: {
          symbol,
          market,
          keyword: this.$store.state.code,
        }
      })

      if (res && res.length > 0) {
        return res[0].Name
      }
    },
    openAppStore() {
      ScTrack && ScTrack.getInstance().track('click_download_floating_layer', {
        source: 'enter_mobile_world_index_page'
      })
      window.open(`https://s.techgp.cn/6l53bZ`)
    },
    loadScript() {
      const ele = document.createElement("script")
      ele.src = 'https://upload.chongnengjihua.com/production/jfnpm/sa-track/1.0.3/jftrack.min.js'
      // 加载完后，调用进入页面埋点
      ele.onload = () => {
        ScTrack.getInstance().track('enter_mobile_world_index_page')
      }
      document.body.appendChild(ele)
    }
  }
}
</script>

<style lang="stylus" scoped>
.head-ad
  height .6rem
</style>